import SystemCustomDivider from "./SystemCustomDivider";

export default function SystemCorrectionDivider() {
    // Used through the app to announce a section with
    // a textual divider

    // BUILD
    return (
        <div className={"w-full flex items-center mt-[16px]"}>
            <SystemCustomDivider color={"bg-greyLight3"} />
            <span className={"font-normal text-[12px] sm:text-[14px] text-greyLight5 px-12 leading-none mb-2 sm:mb-4"}>
                {'Correction'}
            </span>
            <SystemCustomDivider color={"bg-greyLight3"} />
        </div>
    );
}